import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b66c51d8")

_pushScopeId("data-v-b66c51d8")
const _hoisted_1 = { class: "FTLOrderBasic" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "FTLOrderBasic__title" }, "Основная информация", -1)
const _hoisted_3 = { class: "FTLOrderBasic__row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ftl_order_basic_delivery = _resolveComponent("ftl-order-basic-delivery")!
  const _component_ftl_order_basic_car = _resolveComponent("ftl-order-basic-car")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_ftl_order_basic_delivery),
      _createVNode(_component_ftl_order_basic_car)
    ])
  ]))
})